// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"5956ebac","338":"12ac8465","466":"c501d4fd","486":"1188fd25","541":"dfae0b39","576":"bbafba99","581":"5831d86b","753":"e3652084","773":"cfbf8b4b","775":"868d6610","811":"c62d69b8","823":"6f95b835","990":"28f8aa80"}[chunkId] + ".js";
};